export default __webpack_public_path__ + "static/media/uq.cd82fe7d.jpg";